module.exports = __webpack_public_path__ + "static/img/10.724db58.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/img/10.png
// module id = vD6H
// module chunks = 0